import type { ElibooApp } from "@eliboo/api-models";
import type { CommonHttpOptions } from "@eliboo/api/common";

import { useGetApi } from "@eliboo/api/common";

import { useChannelApiOptions } from "../api-options";
export interface CommonChannelOperatorConfigVO {
  /** 业务证照信息单ID */
  businessLicenseInfoSheetId: string;
}

/** token-发送办证人员短信通知 */
export function useApiChannelOperatorConfig(defaultOptions: CommonHttpOptions = useChannelApiOptions()) {
  const url = '/eliboo-app-boot/app-api/v1/channelOperatorConfig/getByBusinessLicenseInfoSheetId';
  return useGetApi<CommonChannelOperatorConfigVO, ElibooApp.ChannelOperatorConfigDTO>(url, defaultOptions);
}
